export class TipoConsulta {

    nome: string;

    constructor(nome: string) {
        this.nome = nome;
    }

    is(tipo: TipoConsulta) {
        return this === tipo;
    }

    isConsultaExterna() {
        return this == CONSULTA_EXTERNA;
    }
    isConsultaInterna() {
        return this == CONSULTA_INTERNA;
    }
    isConsultaApp() {
        return this == CONSULTA_APP_SUITE;
    }
    isConsultaAdmin() {
        return this == CONSULTA_ADMIN;
    }
}

export const CONSULTA_EXTERNA = new TipoConsulta('Consulta Externa');
export const CONSULTA_INTERNA = new TipoConsulta('Consulta Interna');
export const CONSULTA_APP_SUITE = new TipoConsulta('Consulta App Suíte');
export const CONSULTA_ADMIN = new TipoConsulta('Consulta Admin');
